import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT03896945&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT03896945`,
  },
];

class NCT03896945 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:2950,width:'100%',border:'none'}} title="NCT03896945" src="https://connect.trialscope.com/studies/6d545d67-7f11-4c99-bac5-69dfff98b225?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT03896945;
